import { VALIDATE_ZONE, VALIDATE_ZONE_SUCCESS, VALIDATE_ZONE_ERROR, VALIDATE_ZONE_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ValidateZone = (state = initialState, action) => {
  switch (action.type) {
    case VALIDATE_ZONE:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case VALIDATE_ZONE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case VALIDATE_ZONE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case VALIDATE_ZONE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ValidateZone;
